import axios from "axios";
import { BACKEND_URL } from "./api";

const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "st_staff_token";
const CTX_KEY = "st_staff_ctx";
const EVENT_KEY = "st_staff_event";

export function getStaffToken() {
  try { return localStorage.getItem(TOKEN_KEY) || ""; } catch { return ""; }
}
export function setStaffToken(t) {
  try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch { /* noop */ }
}
export function getStaffCtx() {
  try { return JSON.parse(localStorage.getItem(CTX_KEY) || "null"); } catch { return null; }
}
export function setStaffCtx(c) {
  try { if (c) localStorage.setItem(CTX_KEY, JSON.stringify(c)); else localStorage.removeItem(CTX_KEY); } catch { /* noop */ }
}
export function getStaffEvent() {
  try { return localStorage.getItem(EVENT_KEY) || ""; } catch { return ""; }
}
export function setStaffEvent(id) {
  try { if (id) localStorage.setItem(EVENT_KEY, id); else localStorage.removeItem(EVENT_KEY); } catch { /* noop */ }
}

export const staffApi = axios.create({ baseURL: API });
staffApi.interceptors.request.use((cfg) => {
  const t = getStaffToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function clearStaffSession() {
  setStaffToken(null);
  setStaffCtx(null);
  setStaffEvent(null);
}
